import { Feature } from '@tencent/workbench';
import { BaseFillFeature } from '@framework/workbench/drawer/ui/fill/base/base-fill-feature';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { IBackgroundFillShower } from '@tencent/drawing-drawer-components';

@Feature()
export class BackgroundFillShower extends BaseFillFeature implements IBackgroundFillShower {
    public shouldHideButton = () => !(this.isSlideBg && !this.isMasterEditType);

    public shouldResetButtonDisabled = () => this.isResetBtnDisable;

    /**
     * 重置背景按钮是否置灰
     */
    private get isResetBtnDisable()  {
        return this.getSelectionService().currentSlide
            ? !this.getSelectionService().currentSlide?.hasBackground : false;
    }

    private get isMasterEditType(): boolean {
        const appServices = AppServiceProvider.getInstance().getAppServices();
        if (browser.isMobile
            || appServices.getEntryType() !== AppEntryType.PC_EDIT) {
            return false;
        }
        return (appServices as IPcEditorAppServices).editableServiceLayer
            ?.masterLayoutEditService.isMasterEditType ?? false;
    }
}
